import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonColorEnum } from '../enums/button-color.enum';

@Component({
  selector: 'app-login-button',
  templateUrl: './login-button.component.html',
  styleUrls: ['./login-button.component.scss']
})
export class LoginButtonComponent {
  @Input() label: string = '';
  @Input() icon: string = '';
  @Input() right: boolean = false;
  @Input() widthFull: boolean = false;
  @Input() width: string = 'auto';
  @Input() loading: boolean = false;
  @Input() enabled: boolean = true;
  @Input() color: ButtonColorEnum = ButtonColorEnum.primary;

  @Output() clickFunc: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

  handleButtonClick(event: MouseEvent) {
    if (!this.loading && this.enabled) {
      this.clickFunc.emit(event);
    }
  }
}
